
const strings = {
  ERROR_HEADER: 'Whoops! There was an error.',
  ERROR_SUB: 'We are on it. Please try again later.',
  PAGE_NOT_FOUND_SUB: 'Whoops! That page does not exist.',
  NOTIFICATION_LEVEL_ERROR_TEXT: 'We\'re sorry there was an error on the page. Please refresh and try again',
  GENERIC_SUBMIT_ERROR: 'There was an issue with your submission. Please try again later.',
  UNAUTHORIZED_SUB: 'You are not authorized to view this page',
  USER_MACHINE_ROLES: {
    standard_user: 'Guest',
    manager: 'Admin',
  },
};

export default strings;



// WEBPACK FOOTER //
// ./app/strings.js